import { getBrandModelCategory } from './selfserve';

export interface SrConfirmationQueueData {
  refNos: string[];
  serviceRequestLabel: string;
}

const EMPTY_SR_CONFIRMATION_QUEUE: SrConfirmationQueueData = {
  refNos: [],
  serviceRequestLabel: '',
};

const normalizeSrRefNos = (queue: any): string[] => {
  if (!Array.isArray(queue)) {
    return [];
  }

  return queue
    .map((item: any) => String(item || '').trim())
    .filter((item: string, index: number, items: string[]) => Boolean(item) && items.indexOf(item) === index);
};

const getServiceRequestDeviceLabel = (deviceDetails: any): string => {
  const brand = String(deviceDetails?.brand || '').trim();
  const model = String(deviceDetails?.model || '').trim();
  const category = String(
    deviceDetails?.category || deviceDetails?.device_name || deviceDetails?.category_type || ''
  ).trim();

  if (brand || model) {
    return getBrandModelCategory({ brand, model, category });
  }

  return category;
};

const getServiceRequestLabel = (deviceDetailsList: any): string => {
  if (!Array.isArray(deviceDetailsList)) {
    return '';
  }

  return deviceDetailsList
    .map((deviceDetails: any) => getServiceRequestDeviceLabel(deviceDetails))
    .filter((label: string, index: number, labels: string[]) => Boolean(label) && labels.indexOf(label) === index)
    .join(', ');
};

export const normalizeSrConfirmationQueue = (queue: any): SrConfirmationQueueData => {
  if (Array.isArray(queue)) {
    if (Array.isArray(queue[0])) {
      return {
        refNos: normalizeSrRefNos(queue[0]),
        serviceRequestLabel: getServiceRequestLabel(queue[1]),
      };
    }

    return {
      refNos: normalizeSrRefNos(queue),
      serviceRequestLabel: '',
    };
  }

  if (queue && typeof queue === 'object') {
    const refNos = normalizeSrRefNos(
      queue.refNos || queue.serviceRequestRefs || queue.serviceRequestIds || []
    );
    const serviceRequestLabel =
      typeof queue.serviceRequestLabel === 'string' ? queue.serviceRequestLabel.trim() : '';

    return {
      refNos,
      serviceRequestLabel,
    };
  }

  return EMPTY_SR_CONFIRMATION_QUEUE;
};

export const extractSrConfirmationQueue = (
  responseData: any,
): SrConfirmationQueueData | null => {
  const srConfirmationList = responseData?.['show_sr_confirmation'];
  if (!Array.isArray(srConfirmationList)) {
    return null;
  }

  const normalizedQueue = normalizeSrConfirmationQueue(srConfirmationList);
  return normalizedQueue.refNos.length ? normalizedQueue : null;
};
